import type {TreatwellSkeletonApi} from '@treatwell/ui/bookingSkeleton';

// tw-ui owns the global `window.Treatwell` type (a type alias, so it can't be
// augmented);
type TreatwellWithWaf = TreatwellSkeletonApi & {
  wafBotControlReady?: Promise<void>;
};

export function whenWafBotControlReady(callback: () => void) {
  const isWafBotControlReady = (
    window.Treatwell as TreatwellWithWaf | undefined
  )?.wafBotControlReady;
  if (isWafBotControlReady) {
    isWafBotControlReady.then(callback);
  } else {
    callback();
  }
}
